import { useWorkerStore } from '../worker/useWorkerStore';
import { User } from '../generated/gql-types';
import { upsertMany } from '../util/zustand.util';

export const storeAvailableWorkersInWorkerStore = (
  availableWorkers: User[],
): void => {
  try {
    useWorkerStore.setState((state) => {
      const storedWorkersById = new Map(
        state.workers.map((storedWorker) => [storedWorker.id, storedWorker]),
      );

      // Available workers are fetched with a lean field set, so merge rather than
      // replace to keep any detail already loaded for these workers.
      const mergedWorkers = availableWorkers.map((availableWorker) => {
        const storedWorker = storedWorkersById.get(availableWorker.id);
        return storedWorker
          ? { ...storedWorker, ...availableWorker }
          : availableWorker;
      });

      return { workers: upsertMany(state.workers, mergedWorkers) };
    });
  } catch (error) {
    console.error('Error storing available workers in worker store: ', error);
  }
};
